import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const BicycleIcon: FC<IconProps> = ({ width = 19, height = 19, ...rest }) => (
  <Icon type="Bicycle" width={width} height={height} alt="BicycleIcon" {...rest} />
)
